const lpSeederAbi = [
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenA",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "tokenB",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amountA",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "amountB",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountA",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountB",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "deadline",
				"type": "uint256"
			}
		],
		"name": "addLiquidity",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "amountAUsed",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "amountBUsed",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "liquidity",
				"type": "uint256"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amountToken",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountToken",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountETH",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "deadline",
				"type": "uint256"
			}
		],
		"name": "addLiquidityETH",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "amountTokenUsed",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "amountETHUsed",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "liquidity",
				"type": "uint256"
			}
		],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenA",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "tokenB",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amountA",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "amountB",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountA",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountB",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "deadline",
				"type": "uint256"
			}
		],
		"name": "createPairAndAddLiquidity",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "amountAUsed",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "amountBUsed",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "liquidity",
				"type": "uint256"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amountToken",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountToken",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountETH",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "deadline",
				"type": "uint256"
			}
		],
		"name": "createPairAndAddLiquidityETH",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "amountTokenUsed",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "amountETHUsed",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "liquidity",
				"type": "uint256"
			}
		],
		"stateMutability": "payable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenA",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "tokenB",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "liquidity",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountA",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountB",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "deadline",
				"type": "uint256"
			}
		],
		"name": "removeLiquidity",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "amountA",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "amountB",
				"type": "uint256"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "liquidity",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountToken",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "minAmountETH",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "deadline",
				"type": "uint256"
			}
		],
		"name": "removeLiquidityETHSupportingFeeOnTransferTokens",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "amountToken",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "amountETH",
				"type": "uint256"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "syncUserPosition",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "ResidualReturned",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amountA",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amountB",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "timestamp",
				"type": "uint256"
			}
		],
		"name": "SeedingIn",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amountA",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "amountB",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "timestamp",
				"type": "uint256"
			}
		],
		"name": "SeedingOut",
		"type": "event"
	},
	{
		"stateMutability": "payable",
		"type": "receive"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getAllHolderPairs",
		"outputs": [
			{
				"internalType": "address[]",
				"name": "",
				"type": "address[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getAllHolderPairsAndCurrentBalances",
		"outputs": [
			{
				"internalType": "address[]",
				"name": "",
				"type": "address[]"
			},
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1Share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "userLpBalance",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalLpSupply",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token0price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.UserPosition[]",
				"name": "",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "getCurrentUserShare",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1Share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "userLpBalance",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalLpSupply",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token0price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.UserPosition",
				"name": "position",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			}
		],
		"name": "getHolderLastPairIndex",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
		],
		"name": "getHolderPairByIndex",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
		],
		"name": "getSeedingInHistory",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.SeedingSnapshot",
				"name": "",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "startIdx",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "endIdx",
				"type": "uint256"
			}
		],
		"name": "getSeedingInHistoryByIndexRange",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.SeedingSnapshot[]",
				"name": "",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "startTimestamp",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "endTimestamp",
				"type": "uint256"
			}
		],
		"name": "getSeedingInHistoryByTimestamps",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.SeedingSnapshot[]",
				"name": "",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
		],
		"name": "getSeedingOutHistory",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.SeedingSnapshot",
				"name": "",
				"type": "tuple"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "startIdx",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "endIdx",
				"type": "uint256"
			}
		],
		"name": "getSeedingOutHistoryByIndexRange",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.SeedingSnapshot[]",
				"name": "",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "startTimestamp",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "endTimestamp",
				"type": "uint256"
			}
		],
		"name": "getSeedingOutHistoryByTimestamps",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1amount",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.SeedingSnapshot[]",
				"name": "",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "startIdx",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "endIdx",
				"type": "uint256"
			}
		],
		"name": "getUserPositionHistoryByIndexRange",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1Share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "userLpBalance",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalLpSupply",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token0price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.UserPosition[]",
				"name": "",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "startTimestamp",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "endTimestamp",
				"type": "uint256"
			}
		],
		"name": "getUserPositionHistoryByTimestamps",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "token0Share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1Share",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "userLpBalance",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalLpSupply",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token0price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "token1price",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timestamp",
						"type": "uint256"
					}
				],
				"internalType": "struct LpHoldings.UserPosition[]",
				"name": "",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			}
		],
		"name": "getUserPositionHistoryLength",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "holder",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "pair",
				"type": "address"
			}
		],
		"name": "hasPreviouslySeeded",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "holderPairHistory",
		"outputs": [
			{
				"components": [
					{
						"internalType": "uint256",
						"name": "timesSeeded",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "timesRemoved",
						"type": "uint256"
					},
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "totalSeeded",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalRemoved",
								"type": "uint256"
							}
						],
						"internalType": "struct LpHoldings.TokenStats",
						"name": "token0",
						"type": "tuple"
					},
					{
						"components": [
							{
								"internalType": "uint256",
								"name": "totalSeeded",
								"type": "uint256"
							},
							{
								"internalType": "uint256",
								"name": "totalRemoved",
								"type": "uint256"
							}
						],
						"internalType": "struct LpHoldings.TokenStats",
						"name": "token1",
						"type": "tuple"
					}
				],
				"internalType": "struct LpHoldings.PairStats",
				"name": "holderPairStats",
				"type": "tuple"
			},
			{
				"internalType": "uint256",
				"name": "seedingHistoryInIndex",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "seedingHistoryOutIndex",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "userLPPositionHistory",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "index",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];

export default lpSeederAbi;